// extracted by mini-css-extract-plugin
module.exports = {"page":"hG78S_O8","bodyContainer":"_3CM1S-YZ","accountManagementSideBarContainer":"_2ZrqA5ch","rightContent":"_1RNltfAi"};